import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { McpUnoptimizedMatchCard } from "@arcadeai/design-system/components/ui/molecules/mcp-server-picker/unoptimized-match-card";
import { plural } from "../mappers";
import type { UnoptimizedMatch } from "../search";
import type { McpSearchScope, McpServer, Mode, ToolGroup } from "../types";
import { ServerGrid } from "./server-grid";
import { ToolGroups } from "./tool-groups";

export function SearchResults({
  filteredServers,
  filteredToolCount,
  filteredToolGroups,
  hasSearch,
  mode,
  onOpenServer,
  onSetSearchScope,
  onShowUnoptimized,
  onToggleServer,
  onToggleTool,
  scrollContainer = null,
  searchScope,
  selected,
  unoptimizedMatch,
}: {
  filteredServers: McpServer[];
  filteredToolCount: number;
  filteredToolGroups: ToolGroup[];
  hasSearch: boolean;
  mode: Mode;
  onOpenServer: (name: string) => void;
  onSetSearchScope: (scope: McpSearchScope) => void;
  onShowUnoptimized: () => void;
  onToggleServer: (name: string) => void;
  onToggleTool: (fqn: string) => void;
  scrollContainer?: HTMLElement | null;
  searchScope: McpSearchScope;
  selected: Set<string>;
  unoptimizedMatch: UnoptimizedMatch;
}) {
  const isToolsScope = searchScope === "tools";
  const unoptimizedHits = isToolsScope
    ? unoptimizedMatch.toolCount
    : unoptimizedMatch.serverCount;
  const unoptimizedCard =
    hasSearch && unoptimizedHits > 0 ? (
      <McpUnoptimizedMatchCard
        onShow={onShowUnoptimized}
        serverCount={isToolsScope ? 0 : unoptimizedMatch.serverCount}
        toolCount={isToolsScope ? unoptimizedMatch.toolCount : 0}
      />
    ) : null;

  if (hasSearch && searchScope === "tools") {
    const toServers = (
      <Button
        onClick={() => onSetSearchScope("servers")}
        size="sm"
        variant="default"
      >
        {filteredServers.length > 0
          ? `View ${plural(filteredServers.length, "MCP server")}`
          : "View MCP servers"}
      </Button>
    );
    return (
      <ToolGroups
        emptyAction={toServers}
        emptyTitle="No tools match"
        groups={filteredToolGroups}
        onOpenServer={onOpenServer}
        onToggleTool={onToggleTool}
        scrollContainer={scrollContainer}
        selected={selected}
        trailingCard={unoptimizedCard}
      />
    );
  }

  const toTools = hasSearch ? (
    <Button
      onClick={() => onSetSearchScope("tools")}
      size="sm"
      variant="default"
    >
      {filteredToolCount > 0
        ? `View ${plural(filteredToolCount, "tool")}`
        : "View tools"}
    </Button>
  ) : undefined;
  return (
    <ServerGrid
      emptyAction={toTools}
      mode={mode}
      onDrillIn={onOpenServer}
      onToggle={onToggleServer}
      scrollContainer={scrollContainer}
      selected={selected}
      servers={filteredServers}
      trailingCard={unoptimizedCard}
    />
  );
}
